module.exports = {"130505100":"任城镇","130505101":"邢家湾镇","130505102":"辛店镇","130505103":"天口镇","130505200":"西固城乡","130505201":"永福庄乡","130505202":"大屯乡","130505203":"骆庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130505.json
// module id = 219
// module chunks = 0